<template>
  <div>
    <div class="flex-container">
      <div id="dashboard1" class="oberstatus">
        <div id="greeting">
          <div class="imgcon">
            <b-img :src="imageSrc" class="mr-3"/>
            <router-link class="item" to="/home/profile"><a href="" class="setting">
              <b-icon icon="gear"></b-icon>
            </a></router-link>
          </div>
          <div class="greetingtext">
            <p> Willkommen zurück <b> {{ username }} </b>!</p>
            <p>Vermieterübersicht
            </p>
            <router-link class="item" to="/home/events/create">
              <button class="newevent">Neues Event erstellen</button>
            </router-link>
          </div>
        </div>
      </div>
      <div id="dashboard2" class="oberstatus">
        <router-link class="item" to="/home/fields/create">
          <b-button variant="outline-primary">Sportplatz hinzufügen</b-button>
        </router-link>
      </div>
    </div>

  <div>
    <h2> Anfragen </h2>
    <event-list v-if="eventPending.length > 0" :events="eventPending" :user-view="false"/>
    <p v-else> Keine Events</p>
    <h2> Aktive suchende Events  </h2>
    <event-list v-if="eventActive.length > 0" :events="eventActive" :user-view="false"/>
    <p v-else> Keine Events</p>
    <h2> Abgeschlossene Events </h2>
    <event-list v-if="eventFinished.length > 0" :events="eventFinished" :user-view="false"/>
    <p v-else> Keine Events</p>
    <h2> Eigene Sportfelder</h2>
    <field-list :field-delivery="ownfields"/>
  </div>
  </div>
</template>

<script>
import {imageService} from "@/services/image.service";
import EventList from "@/components/EventList";
import {eventService} from "@/services/event.service";
import {fieldService} from "@/services/field.service";
import FieldList from "@/components/FieldList";

export default {
  name: "DashboardRenter",
  components: {FieldList, EventList},
  data() {
    return {
      imageSrc: null,
      eventPending: [],
      eventActive: [],
      eventFinished:[],
      ownfields:[]
    }
  },
  created() {
    imageService.getImage().then(resp => {
      this.imageSrc = resp.path
    });
    this.refreshData()

    fieldService.getFields(0,-1,true).then( res=> {
      this.ownfields = res.items
    })
  },
  methods: {
    refreshData() {
      eventService.getEventsNew(999,0,{type:"requests_pending",sort:"date"}).then ( res=>
      {
        this.eventPending = res.items
      })
      eventService.getEventsNew(999,0,{type:"requests_active",sort:"date"}).then ( res=>
      {
        this.eventActive = res.items
      })
      eventService.getEventsNew(999,0,{type:"requests_finish",sort:"date"}).then ( res=>
      {
        this.eventFinished = res.items
      })
    }
  },
  computed: {
    username() {
      return localStorage.getItem('username')
    }
  }
}
</script>

<style scoped>
/*----------- Content Statusleiste  -----------*/

.flex-container {
  margin-bottom: 30px;
}

.oberstatus {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-between;
  background-color: rgba(255, 255, 255, 0.5);
  padding: 10px;
  border: 1px #ddd solid;
  border-radius: 5px;
  width: 100%;
  margin: 10px;
  flex: 1 0;
}

#dashboard1 {
  flex-basis: 200px;
}

#dashboard2 {
  flex: 2 0;
  display: block;
}

/*----------- Greeting  -----------*/

#greeting {
  display: flex;
  align-items: center;
}

#greeting .imgcon {
  max-width: 80px;
  max-height: 80px;
  border-radius: 50%;
  border: 2px dashed rgb(221, 221, 221);
  float: left;
  vertical-align: top;
  flex-shrink: 0;
  position: relative;
}

.imgcon .setting {
  display: inline-block;
  position: absolute;
  top: 50px;
  right: -10px;
  border-radius: 50%;
  padding: 4px;
  background-color: var(--green);
  color: white;
  line-height: 0;
}

.imgcon img {
  width: 100%;
  max-width: 80px;
  max-height: 80px;
  border-radius: 50%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  display: block;
  object-fit: cover;
}

.greetingtext {
  padding: 20px;
  text-align: justify;
  width: 100%;
}


@media screen and (max-width: 768px) {
  .flex-container {
    flex-direction: column;
    justify-content: center;
  }
}
</style>